<template>
  <div :style="{margin:gap}"><slot></slot></div>
</template>

<script>
export default {
  props: {
    gap: String
  }
}
</script>



// WEBPACK FOOTER //
// box.vue?31e89078